'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEmptyKey = exports.defer = exports.getDisplayName = exports.shallowEqual = undefined;

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// From https://github.com/reactjs/react-redux/blob/master/src/utils/shallowEqual.js
var shallowEqual = exports.shallowEqual = function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
};

var getDisplayName = exports.getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'UnknownComponent';
};

var resolved = Promise.resolve();
var defer = exports.defer = function defer(f) {
  resolved.then(f);
};

var removeEmptyKey = exports.removeEmptyKey = function removeEmptyKey(obj) {
  Object.keys(obj).forEach(function (key) {
    var value = obj[key];
    if ((0, _isEmpty3.default)(value) && (0, _isPlainObject3.default)(value)) {
      delete obj[key];
    } else if ((0, _isPlainObject3.default)(value)) {
      removeEmptyKey(value);
    }
  });

  return obj;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/core/utils.js
// module id = 274
// module chunks = 168707334958949